import React, { Component } from 'react';
import LegoAdminPageContext from '../../pages/legoAdminPageContext';

export class LoadingOverlay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageIsProcessing: 0,
      loadingMessage: 'Processing...'
    };
  }

  runAsync(promise, message = 'Processing...', doneCbk) {
    const noOp = () => true;

    console.log('runAsync', message);
    // This can be called concurrently, to avoid incorrect counts, must be done atomically using react callback
    this.setState(({pageIsProcessing}) => ({ pageIsProcessing: pageIsProcessing+1, loadingMessage: message }));

    const promiseToRun = new Promise(resolve => {
        // promise can be a function that returns a promise, or a promise itself
        resolve(typeof promise === 'function' ? promise() : promise);
    });

    promiseToRun.then(doneCbk || noOp).catch(err => {
      if(err.code === 401) {
        this.props.openLogin();
      } else {
        console.error(err);
        // Using alert is disruptive, console.error should be enough for developers.
        // alert(err);
        this.context.page.showNotification({
          title: 'Error',
          body: err.toString(),
          level: 'error'
        });
      }
    }).finally(() => {
      this.setState(({pageIsProcessing}) => ({ pageIsProcessing: pageIsProcessing - 1 }));
    });
    return promiseToRun;
  }
  
  render() {
    if(this.state.pageIsProcessing > 0) {
      return <div className={'text-secondary LoadingOverlay'}>
        <i className={'material-icons animate-rotating'}>refresh</i>
        <span className={'ml-4'}>&nbsp;{this.state.loadingMessage}</span>
      </div>;
    } else {
      return null;
    }
  }
}

LoadingOverlay.contextType = LegoAdminPageContext;